module.exports = __webpack_public_path__ + "static/media/cc.d26f785d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/cc.png
// module id = 1813
// module chunks = 0